import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MatError,
  MatFormField,
  MatHint,
  MatLabel,
} from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatInput } from '@angular/material/input';
import { AbstractFieldComponent } from '../abstract-field.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FieldLabelComponent } from '../field-label/field-label.component';
import { FieldErrorComponent } from '../field-error/field-error.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'hd-textarea',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    TranslateModule,
    MatInput,
    ReactiveFormsModule,
    FieldLabelComponent,
    MatError,
    FieldErrorComponent,
    MatHint,
    NgClass,
  ],
  templateUrl: './textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class TextareaComponent extends AbstractFieldComponent<FormControl> {}
